import { SnackService } from './../services/snack.service';
import { EnquiriesService } from './../services/enquiries.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Enquiry } from './../models/enquiry.model';
import { Title, Meta } from '@angular/platform-browser';
import { LettersOnlyValidator } from '../validators/letters-only.validator';
import { PhoneNumberValidator } from '../validators/phone-number.validator';
import { NotesValidator } from '../validators/notes.validator';

@Component({
  selector: 'contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss'],
})
export class ContactPageComponent implements OnInit {
  submitted: boolean = false;
  delivered: boolean = false;
  date: Date = new Date();

  contactForm = this.fb.group({
    date: [],
    nameFirst: [
      '',
      [Validators.required, this.lettersOnlyValidator.lettersOnlyValidator],
    ],
    nameLast: [
      '',
      [Validators.required, this.lettersOnlyValidator.lettersOnlyValidator],
    ],
    mobile: [
      '',
      [Validators.required, this.phoneNumberValidator.phoneNumberValidator],
    ],
    email: [
      '',
      [
        Validators.email,
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
        ),
      ],
    ],
    message: ['', [Validators.required, this.notesValidator.notesValidator]],
  });

  // This is a shorter form reference for the HTML Template
  get f(): any {
    return this.contactForm.controls;
  }

  // This data object can be replaced by a call to the server when ready.
  data = {
    title: 'ADIEM | NDIS Plan Management - Contact Details',
    description:
      'ADIEM Plan Management will help you manage your NDIS budget. We handle all of your provider payments and \
      record-keeping that comes with managing your NDIS plan. We will send you monthly statements to help you stay \
      on top of your funds. Please contact us for more information.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/adiem-prod.appspot.com/o/images%2Fplan-manager-contact-details.jpg?alt=media&token=e41695b6-4ead-49b9-916a-db16233ece18',
  };

  constructor(
    private fb: FormBuilder,
    private title: Title,
    private meta: Meta,
    private enquiriesService: EnquiriesService,
    private lettersOnlyValidator: LettersOnlyValidator,
    private phoneNumberValidator: PhoneNumberValidator,
    private notesValidator: NotesValidator,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.title.setTitle(this.data.title);
    this.meta.addTags([
      { name: 'twitter:card', content: 'summary' },
      { name: 'og:url', content: '/contact' },
      { name: 'og:title', content: this.data.title },
      { name: 'og:description', content: this.data.description },
      { name: 'og:image', content: this.data.image },
    ]);
  }

  submitForm() {
    this.findInvalidControls();

    if (this.contactForm.valid) {
      const preparedData = this.prepareFormData();
      this.saveEnquiry(preparedData);
    }
  }

  findInvalidControls() {
    const invalid = [];
    const controls: any = this.contactForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(`${name}: ${controls[name].value}`);
        controls[name].markAsTouched();
      }
    }
    if (invalid.length === 0) {
      console.log('Submitted Successfully');
    } else {
      console.log('Form has Invalid Controls: ', invalid);
    }
    return invalid;
  }

  prepareFormData() {
    const formData = this.contactForm.value;

    const preparedData: Enquiry = {
      nameFirst: formData.nameFirst,
      nameLast: formData.nameLast,
      mobile: String(formData.mobile).replace(/[^0-9]/g, ''),
      email: formData.email,
      message: formData.message,
    };

    return preparedData;
  }

  saveEnquiry(enquiryData: Enquiry) {
    this.submitted = true;
    this.delivered = false;

    this.enquiriesService.sendEnquiry(enquiryData).subscribe({
      next: (response) => {
        this.snackService.passMessage(
          'Enquiry sent successfully',
          2000,
          `enquiry-sent`
        );
        this.delivered = true;
      },
      error: (err) => {
        console.log('Error: ', err);
      },
      complete: () => {},
    });
  }
}
